import { Directive, HostListener } from '@angular/core';
import { LangSwitchComponent } from './lang-switch.component';

@Directive({
  selector: '[appLangSwitchToggle]',
  standalone: true
})
export class LangSwitchToggleDirective {
  constructor(
    private langSwitch: LangSwitchComponent,
  ) {}

  @HostListener('click') onClick(): void {
    this.langSwitch.onOpen();
  }
}
